<template>
  <div class="detail">
    <div v-if="detailItem" class="box">
      <span class="back" @click.stop="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </span>
      <div class="subtitle">{{ detailItem.subtitle }}</div>
      <div class="title">{{ detailItem.title }}</div>
      <div class="time">{{ detailItem.updated_at }}</div>
      <div class="context" v-html="detailItem.content"></div>
    </div>
  </div>
</template>
<script>
import { Report } from '../../../../config/axios/new_api.js'
export default {
  data() {
    return {
      detailItem: {}
    }
  },
  mounted() {
    this.getReportInfo()
  },
  methods: {
    async getReportInfo() {
      let params = {
        id: this.$route.params.id
      }
      const res = await Report.getReportInfo(params)
      if (res.data.status == 1) {
        this.detailItem = res.data.data
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.detail {
  background: #f7f7f9;
  display: flex;
  justify-content: center;
  padding-top: 120px;
  min-width: 1200px;
  .box {
    width: 950px;
    padding: 0 35px;
    background: #fff;
    margin-bottom: 60px;
  }
  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 24px 0;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #9e9da7;
    line-height: 20px;
    i {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3b3946;
    line-height: 37px;
    margin-top: 24px;
  }
  .time {
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9e9da7;
    line-height: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e3e1ea;
  }
  .context {
    margin-top: 16px;
    padding-bottom: 49px;
  }
}
</style>
